import { render } from "./Photo.vue?vue&type=template&id=925435dc"
import script from "./Photo.vue?vue&type=script&lang=js"
export * from "./Photo.vue?vue&type=script&lang=js"

import "./Photo.vue?vue&type=style&index=0&id=925435dc&lang=css"

import exportComponent from "/Users/andrewdrury/Desktop/code/website/altPhoto/photography/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__